import { render, staticRenderFns } from "./policyNumber.vue?vue&type=template&id=f6cd4f20&scoped=true&"
import script from "./policyNumber.vue?vue&type=script&lang=js&"
export * from "./policyNumber.vue?vue&type=script&lang=js&"
import style0 from "./policyNumber.vue?vue&type=style&index=0&id=f6cd4f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cd4f20",
  null
  
)

export default component.exports